import { SYSTEM_GALLERY_FOLDERS, type GalleryFolder } from '@tailoring-crm/shared';
import type { TFunction } from 'i18next';

/**
 * What a folder's row reads.
 *
 * A system folder whose stored `name` still matches its seed's `defaultName` is shown through
 * `t('gallery.folder.<kind>')`, so a fresh shop reads the folder in whatever language it runs
 * in. The moment a shop types a different name, the comparison stops matching and this returns
 * exactly what they typed. Note what this is NOT: it never decides whether a folder is a system
 * one — `isSystemGalleryFolderKind` alone does that — it only decides which of two strings a
 * system folder's row shows.
 */
export function galleryFolderLabel(
  t: TFunction,
  folder: Pick<GalleryFolder, 'kind' | 'name'>,
): string {
  const spec = SYSTEM_GALLERY_FOLDERS.find((one) => one.kind === folder.kind);
  if (spec && folder.name === spec.defaultName) return t(`gallery.folder.${folder.kind}`);
  return folder.name;
}
